
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "UserHunting",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {    
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "Benutzer",
      page: "BenutzerJagd",
      remoteId: "",
      
      
    });

    return {
      request
    };
  }
};
